import styled from "styled-components";
import { media } from "../../../breakpoints";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 52px;
  margin-left: 127px;
  margin-right: 127px;
  margin-top: 20px;

  ${media.desktop`
    margin-left: 24px;
    margin-right: 24px;
  `}

  ${media.tablet`
    margin-left: 16px;
    margin-right: 16px;
    height: auto;
    min-height: 40px;
    flex-wrap: wrap;
    gap: 8px;
  `}
  
  .title{
    font-size: 20px;
    color: #50637F;
  }
  
  .time-left{
    font-size: 16px;
    color: #50637F;
  }
`